"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccountType = void 0;
// Canonical account-role catalogue. Reconciliation picked the complete
// 5-member shape from backend pm/types/index.ts. The 3-member `enum AccountType`
// declarations in backend/src/types/enums.ts and frontend/src/types/enums.ts
// were silent data bugs — any code exhaustively switching on them would have
// treated real CLIENT/SOCIETY accounts as `unknown`. See FR-013, SC-010.
//
// Implementation note: member values are typed as the full union (not narrow
// string literals) so that `[AccountType.X, AccountType.Y].includes(z)`
// patterns throughout the codebase keep working without a per-site cast.
// Code that needs the narrow literal type (e.g. discriminated unions like
// `ClientProfile.account_type = 'CLIENT'`) should use the string literal
// directly.
const ACCOUNT_TYPE_LITERAL = {
    ARCHITECT: 'ARCHITECT',
    CLIENT: 'CLIENT',
    COLLABORATOR: 'COLLABORATOR',
    SALESMAN: 'SALESMAN',
    SOCIETY: 'SOCIETY',
};
exports.AccountType = ACCOUNT_TYPE_LITERAL;
//# sourceMappingURL=account-type.js.map